// This allows us to define a publish schedule in advance and have these promos show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

const promoDrawsScheduleConfig = {
  // Promo Draws
  // "C362B105-A0B8-4F1E-B8DB-BF3FC3CAA2D5": {
  //   key: "examplePromo1",
  //   publish_at: "2024-03-10T11:30:00",
  //   unpublish_at: "2025-07-20T20:00:00",
  //   draw_end: "2025-03-20T20:05:00"
  // },
  // "EA2917A2-2D69-4E51-9E9E-A532CADCF887": {
  //   key: "examplePromo2",
  //   publish_at: "2024-03-24T11:30:00",
  //   unpublish_at: "2025-04-16T20:00:00",
  //   draw_end: "2025-04-11T22:05:00"
  // },
  // "D1C1B0B0-8E66-4E59-BD6A-92DB1196B25D": {
  //   key: "1DayTestForWebsite",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   draw_end: "2025-06-02T00:00:00-04:00" // TODO: Double check timezone on all these config dates
  // },
  "1E0D1EA7-46BE-45D3-B99E-DDA84BED2DFE": {
    key: "multiMillionaireMaker2025",
    publish_at: "2025-05-01T08:00:00",
    unpublish_at: "2025-06-02T18:00:00",
    draw_end: "2025-06-02T00:00:00" // Use the Eastern time that we need, but dont add the -04:00
  },
};

export default promoDrawsScheduleConfig;
